import { useEffect, useState } from 'react';
import HomePageHead from './components/HomePageHead';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotRecommendations from './components/HotRecommendations';
import FeatureSection from './components/FeatureSection';
import LatestContent from './components/LatestContent';

export default function Home() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <>
      <HomePageHead />
      <main>
        {mounted && (
          <>
            <HeroSection />
            <CategoryNav />
            <HotRecommendations />
            <FeatureSection />
            <LatestContent />
          </>
        )}
      </main>
    </>
  );
}